import * as React from 'react'
import { Text, View } from 'react-native'
import styled from '@theme/styled-components'

import { breakpoints } from '@utils/breakpoints'

import SiteIcon from '@components/icon/SiteIcons'
import theme from '@theme/Theme'

const IconsSection = () => {
  return (
    <Section>
      <SectionTitle>Site Icons</SectionTitle>
      <IconRow>
        {icons.map((name) => (
          <IconContainer key={name}>
            <SiteIcon name={name} height={75} />
            <IconLabel>{name}</IconLabel>
          </IconContainer>
        ))}
      </IconRow>
      <IconRow dark>
        {icons.map((name) => (
          <IconContainer key={name}>
            <SiteIcon name={name} width={200} color={theme.colors.primaryDark} />
          </IconContainer>
        ))}
      </IconRow>
    </Section>
  )
}

export default IconsSection

const Section = styled(View)`
  padding: 24px;
  border-color: ${(props) => props.theme.colors.disable};
  border-bottom-width: 1px;
  border-style: solid;

  @media only screen and (min-width: ${breakpoints.phone}px) {
    padding: 24px 48px;
  }
`
const SectionTitle = styled(Text)`
  margin-bottom: 15px;
  text-decoration: underline;
  ${(props) => props.theme.fonts.LargeTitle};
`
const IconRow = styled(View)<{ dark?: boolean }>`
  flex-flow: row wrap;
  ${(props) => props.dark && `background-color: ${props.theme.colors.primary};`}
`
const IconContainer = styled(View)`
  margin: 15px;
  align-items: center;
`
const IconLabel = styled(Text)`
  text-align: center;
  margin-top: 24px;
  ${(props) => props.theme.fonts.Caption2};
`

const icons: SiteIconName[] = ['CDL', 'CHAMP', 'EGARCHE', 'HSR', 'PCI', 'PCP', 'PCV', 'PDV', 'PLB', 'PNV']
